export function CheckboxCircleEmpty({ stroke = '#97948D' }: { stroke?: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Checkbox">
        <rect x="1" y="1" width="18" height="18" rx="9" stroke={stroke} stroke-width="2" />
      </g>
    </svg>
  );
}
